import { Box, CircularProgress } from '@mui/material';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { UnsubmittedSessionRow } from '../../types';
import { UnsubmittedSessionCard } from './unsubmitted-session-card.component';

export type UnsubmittedSessionsCardsProps = {
  rows: UnsubmittedSessionRow[];
};

const AMT_PER_PAGE = 10;

export const UnsubmittedSessionsCards: React.VFC<UnsubmittedSessionsCardsProps> = ({ rows }) => {
  const [ page, setPage ] = useState(1);
  const [ loading, setLoading ] = useState(false);
  const [ dataAmount, setDataAmount ] = useState<number>(AMT_PER_PAGE);
  const observer = useRef<IntersectionObserver>();

  const hasMore = useMemo(() => rows.length > dataAmount, [ dataAmount, rows.length ]);

  useEffect(() => {
    if (page === 1) return;
    setLoading(true);
    setTimeout(() => {
      setDataAmount((prev) => prev + AMT_PER_PAGE);
      setLoading(false);
    }, 250);
  }, [ page ]);

  const loaderRef = useCallback(node => {
    if (loading) return;
    if (observer.current) observer.current.disconnect();

    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && hasMore) {
        setPage(p => p + 1);
      }
    });

    if (node) observer.current.observe(node);
  }, [ loading, hasMore ]);


  return (
    <Box display="flex" flexDirection="column" gap="1rem">
      {rows.slice(0, dataAmount).map((row) => <UnsubmittedSessionCard key={row.appointmentId} row={row} />)}
      {hasMore && (
        <div ref={loaderRef}>
          <Box display="flex" justifyContent="center" my={2}>
            <CircularProgress />
          </Box>
        </div>
      )}
    </Box>
  );
};
